gsap.registerPlugin(ScrollTrigger);

const BESS = {
  init() {
    this.initHeroParallax();
    this.initSectionReveals();
    this.initCounterAnimation();
    this.initSmoothScroll();
    this.initSceneTransitions();
  },

  initHeroParallax() {
    const hero = document.querySelector('.bess-hero');
    if (!hero) return;

    const heroContent = hero.querySelector('.bess-hero__content');
    const heroMedia = hero.querySelector('.bess-hero__media');

    gsap.to(heroContent, {
      y: 120,
      opacity: 0,
      scale: 0.95,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top top',
        end: 'bottom top',
        scrub: 0.8,
      },
    });

    if (heroMedia) {
      gsap.fromTo(heroMedia, { scale: 1 }, {
        scale: 1.15,
        ease: 'none',
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: 0.8,
        },
      });
    }
  },

  initSectionReveals() {
    const revealEls = document.querySelectorAll('.bess-reveal');
    revealEls.forEach((el, i) => {
      gsap.fromTo(el, { opacity: 0, y: 60 }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });

    const slideLeftEls = document.querySelectorAll('.bess-slide-left');
    slideLeftEls.forEach((el) => {
      gsap.fromTo(el, { opacity: 0, x: -80 }, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });

    const slideRightEls = document.querySelectorAll('.bess-slide-right');
    slideRightEls.forEach((el) => {
      gsap.fromTo(el, { opacity: 0, x: 80 }, {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      });
    });
  },

  initCounterAnimation() {
    const counters = document.querySelectorAll('[data-bess-counter]');
    counters.forEach((counter) => {
      const target = parseInt(counter.dataset.bessCounter, 10);
      const suffix = counter.dataset.bessCounterSuffix || '';
      const duration = 2.5;

      ScrollTrigger.create({
        trigger: counter,
        start: 'top 90%',
        once: true,
        onEnter: () => {
          gsap.to(counter, {
            innerText: target,
            duration,
            ease: 'power2.out',
            snap: { innerText: 1 },
            onUpdate: function () {
              counter.innerText = Math.round(this.targets()[0].innerText) + suffix;
            },
          });
        },
      });
    });
  },

  initSceneTransitions() {
    const sections = document.querySelectorAll('.bess-section');
    sections.forEach((section) => {
      const bg = section.querySelector('.bess-section-bg');
      if (!bg) return;

      gsap.fromTo(bg, { scale: 1.05, opacity: 0.4 }, {
        scale: 1,
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
      });
    });
  },

  initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const targetId = anchor.getAttribute('href');
        if (targetId === '#') return;
        const target = document.querySelector(targetId);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  },
};

window.addEventListener('load', () => {
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    BESS.init();
  }
});
